import { CheckList } from '@work4all/models/lib/Classes/CheckList.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/checkList-table-schema.json';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];
const FORCE_REQUEST_FIELDS: CheckList<EMode.query> = {
  done: null,
};

export function ChecklistsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<CheckList, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    forceRequestFields: FORCE_REQUEST_FIELDS,
    rowModifiers: (value) => {
      return {
        isFaded: value.done,
      };
    },
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}
